export default __webpack_public_path__ + "static/media/survey-background.a5d00374.svg";